import React from 'react';

const AboutSection = () => {
  return (
    <section className="vs-about position-relative space py-4">
      <img
        src="/img/icons/plain-globe.png"
        alt="plain-globe"
        className="about-icon-1 animate-parachute"
      />
      <img
        src="/img/icons/map.png"
        alt="plain-globe"
        className="about-icon-2 animate-parachute"
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span
                className="sec-subtitle text-capitalize fade-anim pt-2"
                data-direction="top"
              >
                
              </span>
              <h2 className="sec-title fade-anim" data-direction="bottom">
                Reliable Rides, Every Time <br />
                Travel Smart with Mauli Cabs
              </h2>
            </div>
          </div>
        </div>
        <div className="row g-4 align-items-center">
          <div className="col-md-6 order-1 order-md-0">
            <div className="about-info-area">
              <div className="title-area mb-4">
                <span className="sec-subtitle text-capitalize">
                  Explore Our Services
                </span>
                <h2 className="sec-title">Your Trusted Travel Partner</h2>
              </div>
              <div className="about-info">
                <p>
                  Mauli Cabs offers reliable, comfortable, and on-time cab services
                  for city travel and outstation trips. With professional drivers,
                  transparent pricing, and 24/7 availability, we ensure a smooth
                  experience every time you ride with us.
                </p>
                <div className="services-lists">
                  <ul className="custom-ul">
                    <li className="fade-anim" data-delay="0.30">
                      ✅ On-time pickup & drop
                    </li>
                    <li className="fade-anim" data-delay="0.40">
                      ✅ Clean and well-maintained vehicles
                    </li>
                    <li className="fade-anim" data-delay="0.50">
                      ✅ Easy booking & flexible payment options
                    </li>
                    <li className="fade-anim" data-delay="0.60">
                      ✅ City, Airport & Outstation travel
                    </li>
                  </ul>
                </div>
                <a href="/services" className="vs-btn style6 text-capitalize">
                  view all services
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-6 order-0 order-md-1">
            <div className="about-thumb fade-anim" data-direction="right">
              <img
                src="/images/cab.png"
                // src="/img/about/about-thumb.png"
                alt="about Mauli Cabs"
                className="w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
